import { Typography } from "@mui/material";
import Container from "@mui/material/Container";
import ContainerXL from "./container-xl.common";
import { useTranslations } from "next-intl";

export const PageSection = ({
  dull = false,
  heading,
  children,
  variant,
  sx = {},
}) => {
  const t = useTranslations();
  return (
    <Container
      sx={{ 
        padding: { xs: "2rem 0 !important", md: "5rem 0 !important" },
        width: "100%",
        minWidth: "100%", 
        overflow: "hidden",
        ...sx 
      }}
      variant={variant}
      {...(dull && { variant: "dull" })}
      maxWidth={false}
    >
      <ContainerXL>
        {heading && (
          <Typography
            variant="h3"
            sx={{
              fontWeight: 700,
              margin: { xs: "2rem auto", md: "5rem auto" },
              marginTop: 0,
              textAlign: "center",
            }}
          >
            {t(heading)}
          </Typography>
        )}
        {children}
      </ContainerXL>
    </Container>
  );
};

export default PageSection;